import React from 'react'
import cx from 'classnames'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { ym, compose, getCityName } from 'helpers'

import injectGlobals from 'local_modules/injectGlobals'

import MarketplaceCollapsibleList from './MarketplaceCollapsibleList/MarketplaceCollapsibleList'

import s from './MarketplaceList.scss'


const MarketplaceList = ({ className, listClassName, activeLayer, navigation }) => (
  <div className={className}>
    {/*{*/}
      {/*Boolean(activeLayer) && (*/}
        {/*<LayerLink*/}
          {/*id={activeLayer.id}*/}
          {/*title={activeLayer.title}*/}
          {/*isActive*/}
        {/*/>*/}
      {/*)*/}
    {/*}*/}
    {
      navigation.map((category) => {
        const { id, title, tools, isSelected, onClick } = category
        
        return (
          <MarketplaceCollapsibleList
            key={id}
            className={cx(s.mainList, listClassName, {
              // [s.selected]: isSelected,
            })}
            title={title}
            isSelected={isSelected}
            onClick={onClick}
          >
            {
              Boolean(tools) && tools.map((tool) => (
                tool.isAreasVisible ? (
                  <MarketplaceCollapsibleList
                    className={s.list}
                    key={tool.id}
                    title={tool.title}
                    isSelected={tool.isSelected}
                    onClick={tool.onClick}
                  >
                    {
                      tool.areas.map((area) => (
                        <div
                          key={area.id}
                          className={cx(s.list, s.link, {
                            [s.active]: area.isSelected,
                          })}
                          onClick={area.onClick}
                        >
                          {area.title}
                        </div>
                      ))
                    }
                  </MarketplaceCollapsibleList>
                ) : (
                  <div
                    key={tool.id}
                    className={cx(s.list, s.link, {
                      [s.active]: tool.isSelected,
                    })}
                    onClick={tool.onClick}
                  >
                    {tool.title}
                  </div>
                )
              ))
            }
          </MarketplaceCollapsibleList>
        )
      })
    }
  </div>
)


export default compose(
  injectGlobals(({ globals }) => ({
    cityName: getCityName(globals),
  })),
  connect({
  // copy to areaLayout
  navigation: (state, props) => {
    const {
      marketplace: {
        layersNavigation: {
          category, area, tool, toolType,
          categories, areas, tools: _tools, nomenclature, rpcNomenclature,
        },
      },
      routing: {
        locationBeforeTransitions: {
          query: { noFilter },
        },
      },
    } = state

    const tools = _tools
      .filter(({ active }) => noFilter || active)
      .map(({ areas, ...tool }) => ({
        ...tool,
        areas: noFilter ? areas : areas.filter(({ active, area }) => active && area.active),
      }))
      .filter(({ areas }) => Boolean(areas.length))

    const { toggleClose, cityName } = props

    const sportCategory = categories[0]

    const sport = {
      id: sportCategory.id,
      title: sportCategory.title,
      isSelected: sportCategory.id === category,
      onClick: () => {
        ym('marketplace_sport_2')

        actions.marketplace.layersNavigation.setCategory(sportCategory.id)

        if (tools.length === 1) {
          actions.marketplace.layersNavigation.setToolType(tools[0].id)

          const toolAreas = tools[0].areas

          if (toolAreas.length === 1) {
            actions.marketplace.layersNavigation.setTool(toolAreas[0].id)
            actions.marketplace.layersNavigation.setArea(toolAreas[0].area.id)
            // actions.marketplace.layersNavigation.setActive(false)
            if (toggleClose) {
              toggleClose()
            }
          }
        }
      },
      tools: tools.map(({ id, name, areas }) => {
        const isAreasVisible = Boolean(areas.length > 1)

        return {
          id,
          title: name,
          isSelected: id === toolType,
          isAreasVisible,
          onClick: () => {
            actions.marketplace.layersNavigation.setToolType(id)

            if (!isAreasVisible) {
              actions.marketplace.layersNavigation.setTool(areas[0].id)
              actions.marketplace.layersNavigation.setArea(areas[0].area.id)
              // actions.marketplace.layersNavigation.setActive(false)
              if (toggleClose) {
                toggleClose()
              }
            }
          },
          areas: areas.map(({ id, name, area: { id: areaId, shortName: areaName } }) => ({
            id,
            title: `${areaName} / ${name}`,
            isSelected: areaId === area && tool === id,
            onClick: () => {
              actions.marketplace.layersNavigation.setTool(id)
              actions.marketplace.layersNavigation.setArea(areaId)
              // actions.marketplace.layersNavigation.setActive(false)
              if (toggleClose) {
                toggleClose()
              }
            },
          }))
        }
      })
    }

    if (categories[1]) {
      const eduCategory = categories[1]

      const edu = {
        id: eduCategory.id,
        title: eduCategory.title,
        isSelected: eduCategory.id === category,
        onClick: () => {
          ym('marketplace_school_2')

          actions.marketplace.layersNavigation.setCategory(eduCategory.id)

          if (nomenclature.length === 1) {
            const { id } = nomenclature[0]
            actions.marketplace.layersNavigation.setToolType(id)

            actions.marketplace.layersNavigation.setTool(id)
            actions.marketplace.layersNavigation.setArea(id)

            if (toggleClose) {
              toggleClose()
            }
          }
        },
        tools: nomenclature.map(({ id, title }) => {
          return {
            id,
            title,
            isSelected: id === toolType,
            isAreasVisible: false,
            onClick: () => {
              actions.marketplace.layersNavigation.setToolType(id)

              actions.marketplace.layersNavigation.setTool(id)
              actions.marketplace.layersNavigation.setArea(id)

              if (toggleClose) {
                toggleClose()
              }

              // if (!isAreasVisible) {
              //   actions.marketplace.layersNavigation.setTool(areas[0].id)
              //   actions.marketplace.layersNavigation.setArea(areas[0].area.id)
              //   // actions.marketplace.layersNavigation.setActive(false)
              //   // props.toggleClose()
              // }
            },
          }
        })
      }

      if (cityName === 'sarov') {
        const rpc = {
          id: 'rpc',
          title: 'Православная гимназия',
          isSelected: 'rpc' === category,
          onClick: () => {
            actions.marketplace.layersNavigation.setCategory('rpc')
  
            if (rpcNomenclature.length === 1) {
              const { id } = rpcNomenclature[0]
              actions.marketplace.layersNavigation.setToolType(id)
  
              actions.marketplace.layersNavigation.setTool(id)
              actions.marketplace.layersNavigation.setArea(id)
  
              if (toggleClose) {
                toggleClose()
              }
            }
          },
          tools: (rpcNomenclature || []).map(({ id, title }) => {
            return {
              id,
              title,
              isSelected: id === toolType,
              isAreasVisible: false,
              onClick: () => {
                actions.marketplace.layersNavigation.setToolType(id)
  
                actions.marketplace.layersNavigation.setTool(id)
                actions.marketplace.layersNavigation.setArea(id)
  
                if (toggleClose) {
                  toggleClose()
                }
              },
            }
          })
        }

        return [ sport, edu, rpc ]
      }

      return [ sport, edu ]
    }

    return [ sport ]
  },
}))(MarketplaceList)